import * as React from 'react';
import Icon from 'react-native-vector-icons/AntDesign'
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import { redBorderInputColor } from '../../colors';

const ErrorEmptyNameBox = (props) => props.error && <View style={styles.errorEmptyNameBox}> 
                <Text style={styles.textError}> 
                    <Icon style={styles.alertIcon} name='exclamationcircle'> </Icon>
                    {props.error}
                </Text>
            </View>

export default  ErrorEmptyNameBox;

const styles = StyleSheet.create({
    errorEmptyNameBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
    },
    textError: {
        color: redBorderInputColor,
        paddingBottom: 16,
        fontSize: 12,
    },
    alertIcon: {
        paddingRight: 3,
    },
})
